// German UI messages and labels
export const MESSAGES = {
  // Toast messages
  ORDER_SUCCESS: 'Bestellung erfolgreich!',
  ORDER_FAILED: 'Bestellung fehlgeschlagen',
  PASSWORD_ERROR: 'Falsches Passwort!',

  // Button labels
  CLEAR_CART: '🗑️ Leeren',
  OVERVIEW: '📋 Übersicht',

  // Product table headers
  PRODUCT_COLOR: 'Farbe',
  PRODUCT_NAME: 'Name',
  PRODUCT_PRICE: 'Preis',
  PRODUCT_DEPOSIT: 'Pfand',
  PRODUCT_BON: 'Bon',
  PRODUCT_ACTIONS: 'Aktionen',

  // Product actions
  PRODUCT_EDIT: 'Bearbeiten',
  PRODUCT_CLONE: 'Klonen',
  PRODUCT_DELETE: 'Löschen',

  // Misc
  NO_PRODUCTS: 'Keine Produkte vorhanden.',
  BON: 'Bon',
}

// Product colors for selection
export const PRODUCT_COLORS = [
  { value: '#FF6B6B', label: 'Korallenrot' },
  { value: '#4ECDC4', label: 'Teal' },
  { value: '#45B7D1', label: 'Himmelblau' },
  { value: '#96CEB4', label: 'Salbeigrün' },
  { value: '#FFEAA7', label: 'Hellgelb' },
  { value: '#DDA0DD', label: 'Pflaume' },
  { value: '#98D8C8', label: 'Minze' },
  { value: '#F7DC6F', label: 'Goldgelb' },
  { value: '#BB8FCE', label: 'Lavendel' },
  { value: '#85C1E9', label: 'Hellblau' },
]